import React from 'react';
import ProjectDetailRow from './ProjectDetailRow';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import { useTranslation } from 'react-i18next';
import TopRowTitle from '../TopRowTitle';
const CONTRACTOR_KEYS_VERSION_7 = [{
  name: 'dcr_remun_paid',
  translationKey: 'dcr_remun_paid'
}, {
  name: 'dcr_remun_paid_not_in_20_26',
  translationKey: 'dcr_remun_paid_not_in_20_26'
}, {
  name: 'dcr_remun_paid_in_20_26',
  translationKey: 'dcr_remun_paid_in_20_26'
}];
const CONTRACTOR_KEYS_VERSION_8 = [{
  name: 'dcr_remun_paid',
  translationKey: 'dcr_remun_paid'
}, {
  name: 'dcr_remun_paid_before_28_3_24',
  translationKey: 'dcr_remun_paid_before_28_3_24'
}, {
  name: 'dcr_remun_paid_after_27_3_24',
  translationKey: 'dcr_remun_paid_after_27_3_24'
}];
const ProjectDetailsContractors = _ref => {
  let {
    projectDetails,
    isVersion8
  } = _ref;
  const {
    t
  } = useTranslation();
  const contractorKeys = isVersion8 ? CONTRACTOR_KEYS_VERSION_8 : CONTRACTOR_KEYS_VERSION_7;
  const renderContractors = projectDetails.calculations.contractors_calculation.map(contractorsCalculation => {
    if (contractorsCalculation.errors) {
      return /*#__PURE__*/React.createElement("div", {
        key: contractorsCalculation.name
      }, /*#__PURE__*/React.createElement("p", null, "Calculation for ", /*#__PURE__*/React.createElement("strong", null, contractorsCalculation.name), " has an error:"), /*#__PURE__*/React.createElement("p", null, contractorsCalculation.errors), /*#__PURE__*/React.createElement("br", null));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: contractorsCalculation.name
    }, contractorKeys.map((field, i) => {
      const label = "".concat(t(field.translationKey), " for ").concat(contractorsCalculation.name);
      return /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [field.name, contractorsCalculation[field.name]],
        translationKey: field.translationKey,
        label: i === 0 ? label : null,
        index: i + 'contractor',
        projectDetails: projectDetails,
        key: "".concat(contractorsCalculation.name, "-").concat(field.name, "-rowData"),
        disabled: true,
        rowClass: i === 0 ? 'mt-3' : ''
      });
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Details of contract research (must be completed per contractor)'))
  }), renderContractors);
};
export default ProjectDetailsContractors;